import React from 'react';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import './DateRangePicker.scss';
import { Moment } from 'moment';
import styled from 'styled-components';
import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';

interface Props {
  title: string;
  label?: string;
  value: Moment;
  enablePast?: boolean;
  onChange: (arg: Moment) => void;
}

const Wrapper = styled.div<{ labelled: boolean }>`
  margin-bottom: ${({ labelled }) => (labelled ? 0 : '16px')};
  margin-top: ${({ labelled }) => (labelled ? 0 : '20px')};
`;

const DateRangePicker: React.FunctionComponent<Props> = (props) => {
  return (
    <Wrapper labelled={!!props.label}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <DateTimePicker
          disablePast={!!!props.enablePast}
          ampm={false}
          label={props.label}
          fullWidth={!!props.label}
          value={props.value}
          onChange={(date) => date && props.onChange(date)}
        />
      </MuiPickersUtilsProvider>
    </Wrapper>
  );
};

export default DateRangePicker;
